<template lang="pug">
.intro
  .cover
    .container
      h1 前沿社如何帮到你？
      .guide
        a.guide-item(href="#workshop")
          p Frontier Workshop
          p 前沿工作坊
        a.guide-item(href="#fieldstudy")
          p Field Study
          p 近场研究
        a.guide-item(href="#overclocking")
          p Overclocking Camp
          p 超频之旅
  .container
    .workshop#workshop
      .intro-img
        img(src='../assets/imgs/intro_v1.jpg')
      .intro-title
        .title
          h1 Frontier
          h1 Workshop
          h1.cn 前沿工作坊
        p 在世界级科学家的顾问和推荐下，每年与来自全球顶级学府的超过 20 位前沿科技研究者产生连接，深入了解全球最领先的科技，提供市场化视角的思考、对未来产品与应用的建议，为实验室项目商业化提供路径。
      .subhead
        h2 2019年关注领域
      .module
        .module-item
          .item-title 5G 通讯
          .item-subtitle 5G
          .cover-tips 更高速的连接和更低的延时，将成为哪些领域的引爆点？又将创造哪些新的应用场景？
        .module-item
          .item-title 智能制造
          .item-subtitle Intelligent<br>Manufacturing
          .cover-tips 更密集的生产数据和明确的用户需求，将如何改造传统的制造流程？
        .module-item
          .item-title AI 落地
          .item-subtitle Landing AI
          .cover-tips 强算力如何提升传统行业的效率？跳脱思维局限，选择AI更广泛地落脚点。
        .module-item
          .item-title 未来出行
          .item-subtitle Future<br>Transportation
          .cover-tips 算法如何与场景和硬件成本达到动态平衡？又如何预期天马行空出行方式的落地可行性？
        .module-item
          .item-title 核心元器件
          .item-subtitle Core Electronic<br>Components
          .cover-tips 关注国内核心通用元器件的商业路径，发现焦点之外元器件的技术突破。
        .module-item
          .item-title 更多前沿领域
          .item-subtitle More...
      .subhead
        h2 与全球最权威的专家共同思考
      .expert-wapper
        ul
          li.expert-item(v-for="(item, $index) in expert.items")
            img(:src="['/static/img/'+item.pic]")
            .info
              p.title {{item.name}}
              p.from {{item.from}}
              p.position(v-html="item.position")
              p.from {{item.from2}}
              p.position(v-html="item.position2")
            p.brief {{item.brief}}
      .tips * 极客公园正在通过以上嘉宾连接全球最优秀的前沿科技研究者，部分嘉宾也将参与前沿工作坊。

  #fieldstudy
  .field-study
    .container
      .intro-title
        .title
          h1 Field
          h1 Study
          h1.cn 近场研究
        p CEO 对 CEO，真问题对真问题。每期走进一家优秀热门科技公司，通过 CEO 间内部探讨和闭门交流，促进有价值的思考，推动经验分享与洞见碰撞，推动没有边界的创新思维和合作可能。

      //- .subhead
        h2 与中国最优秀的创业者一同学习

      .fieldstudy-list
        .tag {{slides.length && slides[currentSlide].tag}}
        swiper.out(:options="swiperOption" ref="mySwiper")
          swiper-slide(v-for="guest, index in slides", :key="`guest_${index}`")
            .item
              img(:src="require(`../assets/imgs/fieldstudy/${guest.pic}.jpg`)")
              .title {{guest.title}}
              .description {{guest.description}}

  #overclocking
  .overclocking-camp
    .container.bg-map
      .intro-img
        img(src='../assets/imgs/intro_v2.jpg')
      .intro-title
        .title
          h1 OverClocking
          h1 Camp
          h1.cn 超频之旅
        p 与最优秀的企业家一起在全球范围内从前沿的科技到创新的思想，去寻求认知的突破和升级，也在共同的交流和思考之中进行思维的徒步。

      .intro-step
        .intro-step-item
          h3 「前沿之前」超频之旅
          p <icon-clock></icon-clock>5月 <icon-location></icon-location>英国

        .intro-step-item
          h3 「探索前沿与商业」超频之旅
          p <icon-clock></icon-clock>9月 <icon-location></icon-location>美国

        .intro-step-item
          h3 Web Summit破冰之旅
          p <icon-clock></icon-clock>11月 <icon-location></icon-location>葡萄牙

        //- .intro-step-item
        //-   h3 美国超频之旅
        //-   p <icon-clock></icon-clock>9月-10月 <icon-location></icon-location>美国
        //-
        //- .intro-step-item
        //-   h3 Web Summit破冰之旅
        //-   p <icon-clock></icon-clock>11月 <icon-location></icon-location>葡萄牙

      .subhead
        h2 与世界级创新者的深度交流

      .world-innovator
        ul
          li
            img(src='../assets/imgs/world_innovator_01.jpg')
            p.name Elon Musk
            p.company Tesla
            p.position 创始人&CEO
          li
            img(src='../assets/imgs/world_innovator_02.jpg')
            p.name John Sculley
            p.company 前Apple CEO
            p.position 风险投资人
          li
            img(src='../assets/imgs/world_innovator_03.jpg')
            p.name 杨致远
            p.company Yahoo
            p.position 创始人
          li
            img(src='../assets/imgs/world_innovator_04.jpg')
            p.name Dick Costolo
            p.company Twitter
            p.position 前CEO
          li
            img(src='../assets/imgs/world_innovator_05.jpg')
            p.name Brian Chesky
            p.company Airbnb
            p.position 创始人&CEO
          li
            img(src='../assets/imgs/world_innovator_06.jpg')
            p.name Ben Silbermann
            p.company Pinterest
            p.position 创始人&CEO
          li
            img(src='../assets/imgs/world_innovator_07.jpg')
            p.name Alex Kipman
            p.company 微软
            p.position 全球副总裁、HoloLens总负责

        .world-innovator-more
          dl
            dt Harry Shum 沈向洋
            dd 微软全球执行副总裁、微软全球研究院院长
            dt Alex Kipman
            dd 微软全球副总裁、HoloLens总负责
            dt Scott Guthrie
            dd 微软执行副总裁、主管云计算与企业级事业部
            dt 陆奇
            dd 前微软全球执行副总裁、应用和服务部负责人
            dt David Ku
            dd 微软全球应用与服务部副总裁
            dt Alan Stern
            dd 前 NASA 新地平线号首席研究员
            dt Oliver Cameron
            dd Udacity工程和产品副总裁
            dt Meron Gribetz
            dd Meta CEO
            dt 杨培东
            dd 伯克利大学教授、美国科学院院士、全球著名化学家、材料科学家
          dl
            dt Ryan Germick
            dd Google Design设计总监、首席设计师
            dt Nathan Burba
            dd Survios CEO
            dt David Reitze
            dd 加州理工大学LIGO实验室执行总监、教授
            dt Jessica Lessin
            dd The Information 创始人
            dt Sonny Vu
            dd Misfit 创始人&CEO
            dt Yves Behar
            dd fuseproject 创始人&CEO
            dt Connie Chan
            dd Andreessen Horowitz ( A16Z）合伙人
            dt George O’Neal
            dd Hyperloop One高级副总裁
            dt James Chung
            dd Reload Studio CEO
            dt Lisa Q. Fetterman
            dd Nomiku 联合创始人、CEO
          .tips * 以上为2014-2016年参与极客公园交流的部分海外嘉宾。

      .subhead
        h2 这些企业家曾参加超频之旅

      .member
        ul
          li.member-item(v-for="(name, $index) in entrepreneurs")
            p.name {{name}}
            p.company {{members[name].company}}
            p.position(v-html="members[name].position")

</template>

<script>
var IconClock = {
  template: '<svg class="octicon" version="1.1" viewBox="0 0 1300 1000"><path d="M511.913993 63.989249c-247.012263 0-447.924744 200.912481-447.924744 447.924744s200.912481 447.924744 447.924744 447.924744 447.924744-200.912481 447.924744-447.924744S758.926256 63.989249 511.913993 63.989249zM671.199059 575.903242 480.263397 575.903242c-17.717453 0-32.166639-14.449185-32.166639-32.166639L448.096758 289.15572c0-17.717453 14.277171-31.994625 31.994625-31.994625s31.994625 14.277171 31.994625 31.994625l0 222.930287 159.285066 0c17.717453 0 31.994625 14.277171 31.994625 31.994625S688.916513 575.903242 671.199059 575.903242z" /></svg>'
}
var IconLocation = {
  template: '<svg class="octicon" version="1.1" viewBox="0 0 1200 1000"><path d="M511.913993 63.989249C317.882076 63.989249 159.973123 221.898203 159.973123 415.930119c0 187.323366 315.473879 519.998656 328.890979 534.103813 6.020494 6.364522 14.449185 9.976818 23.221905 9.976818 0.172014 0 0.516042 0 0.688056 0 8.944734 0 17.545439-4.128339 23.393919-11.008903l109.22896-125.054258c145.179909-177.690576 218.629934-314.957836 218.629934-407.845456C864.026877 221.898203 706.117924 63.989249 511.913993 63.989249zM511.913993 575.903242c-88.415253 0-159.973123-71.55787-159.973123-159.973123s71.55787-159.973123 159.973123-159.973123 159.973123 71.55787 159.973123 159.973123S600.329246 575.903242 511.913993 575.903242z" /></svg>'
}
import api from '../store/api'
import 'swiper/dist/css/swiper.css'
import { swiper, swiperSlide } from 'vue-awesome-swiper'

export default {
  name: 'intro',
  components: {
    'icon-clock': IconClock,
    'icon-location': IconLocation,
    swiper,
    swiperSlide
  },
  data() {
    const _this = this
    return {
      link: 'http://cn.mikecrm.com/J6cZ7QZ',
      guests: ["黎万强", "周鸿祎", "沈晖", "姬十三", "罗敏", "张志东", "胡玮炜", "周源", "傅盛", "余凯", "陈大年", "黄汪"],
      entrepreneurs: ["王小川", "张一鸣", "张涛", "张志东", "黎万强", "傅盛", "周航", "李志飞", "徐昕泉", "曹毅", "刘宗孺", "陶喆", "张向东", "曾德钧", "胡玮炜", "周源", "陈磊", "冯鑫", "刘作虎"],
      slides: [
        {
          tag: '　',
          title: '为什么要「近场研究」？',
          description: '与一群同样优秀的企业家，跳出新闻与传说，深度走近一家最值得关注的高成长公司，在  CEO  之间去中心化的闭门交流中，无顾忌的思考碰撞，获得最完整的信息，从「孤军奋战」到「合伙学习」，在相互激发中更高效地获得思维的成长，从而带动组织的进化。图为 2017 年「近场研究」走近小米，与联合创始人黎万强交流小米成立七年方法论。',
          pic: 'home'
        },
        {
          tag: '2018.11.15 | 知乎',
          title: '如何找到组织的「北极星」，赢得竞争、收获成长？',
          description: '2018 年，知识分享经济领域经历了几次复杂的激烈竞争。外界看似是最终知乎打赢了，宣布完成 E 轮 2.7 亿美元融资，交出用户数超过 2 亿、回答数超过 1.2 亿的成绩单。但创始人 & CEO 周源却认为「赢」的原因不在于竞争，而是来自于组织的自我进化。「近场研究」带领 15 位企业家走近知乎，深入了解知乎在面对竞争时，从自身出发对组织提出的思考总结。',
          pic: 'zhihu'
        },
        {
          tag: '2019.01.20 | Pixar 皮克斯',
          title: '如何让一个组织可以持续生产「创新」？',
          description: '皮克斯出品的动画有《玩具总动员》《海底总动员》《机器人瓦力》《飞屋环游记》等。这家成立近 30 年的传奇动画公司，截止 2018 年共发布了 20 部动画长片，获得 15 次奥斯卡等奖项。「近场研究」特别邀请到皮克斯动画联合创始人 & 总裁 Ed Catmull，探究皮克斯这些电影背后，源源不断的灵感和创意从何而来？科学家、艺术家、商业家之间如何融合互相激发？',
          pic: 'pixar'
        },
        {
          tag: '2017.11.18 | 深圳',
          title: '腾讯的成长基因解密，关于产品和技术的思考',
          description: '十几年的时间，腾讯从一家初创公司成长为十几亿用户量的互联网巨头，张志东作为主要创办人之一和技术专家、前 CTO，亲身推动了腾讯的高速成长过程。「近场研究」曾特别邀请到张志东分享他的产品思考和方法论，试图解密腾讯的快速成长路径，与现场 20 余位企业家共同探讨在人才培养、企业文化方面的建立和传承。',
          pic: 'tencent'
        },
        {
          tag: '2019.01.18 | 美团',
          title: '如何发挥组织能力不断获得更大的成功？',
          description: '2018 年 9 月，成立八年的美团在港交所挂牌上市，成为中国上市科技公司中仅次于 BAT 的第四名。外界总结美团是「后发先至」，即在已有玩家的情况下进入一个相当成熟的市场，最终获得一个不小的份额。那么美团如何解答外界对其战略的猜测，他们又是怎么找到一个个全新业务的增长驱动力？「近场研究」曾邀请到美团联合创始人王慧文，分享美团的组织发展心得。',
          pic: 'meituan'
        },
        // {
        //   tag: '2017.06.04 | 北京',
        //   title: '机会？陷阱？智能音箱大热背后的冷思考',
        //   description: 'Amazon、Google、Apple 等巨头纷纷进军智能音箱市场，国内掀起一波热潮之时，「近场研究」组织话题，邀请多次与 Amazon 进行深入交流的 IoT、人工智能的企业 BroadLink，听创始人 & CEO 刘宗孺分享来自 Amazon 内部的一手信息，深度探讨国内外智能家居市场的环境差异，以及智能家居产品到底有多大的「连接」想象力？',
        //   pic: 'soundbox'
        // }
      ],
      currentSlide: 0,
      swiperOption: {
        // slidesPerView: 1.1,
        loop: true,
        allowTouchMove: true,
        autoplay: {
          delay: 5000,
          stopOnLastSlide: false,
          disableOnInteraction: false,
        },
        lazy: {
          loadPrevNext: true,
        },
        navigation: {
          nextEl: '.arrow-right',
          prevEl: '.arrow-left',
        },
        on: {
          slideChange () {
            _this.currentSlide = this.realIndex || 0
          }
        },
      }
    }
  },
  computed: {
    members() {
      return this.$store.state.config['members']
    },
    expert() {
      return this.$store.state.config['expert']
    }
  }
}
</script>

<style lang="stylus">
@import '../assets/css/var'
#overclocking
#fieldstudy
  margin-top -50px
  margin-bottom 50px
.octicon
  vertical-align top
  display inline-block
  fill currentColor
  width auto
  height 1em
.module
  display flex
  flex-wrap wrap
  color #fff
  margin-left -20px
  margin-right -20px
  .module-item
    width 50%
    height 31vw
    display flex
    flex-direction column
    justify-content center
    align-items center
    background-size cover
    background-repeat no-repeat
    background-position center
    background-blend-mode multiply
    position relative
    .item-title
      font-size 20px
      letter-spacing 0.2em
      font-weight 700
      position relative
      line-height 2
      z-index 1
    .item-subtitle
      font-size 14px
      position relative
      z-index 1
    .item-little
      position relative
      font-size 1.3rem
      z-index 1
    &::before,
    .cover-tips
      display block
      content ''
      position absolute
      left 0
      right 0
      top 0
      bottom 0
      background rgba(0,0,0,0.5)
      z-index 0
    .cover-tips
      background $yellow
      z-index 2
      opacity 0
      transition all 0.4s
      display flex
      justify-content center
      align-items center
      font-size 1.5rem
      line-height 1.5
      padding 4em
    // &:hover
    //   .cover-tips
    //     opacity 1
    &:nth-child(6):hover::after
      content none
    &:nth-child(1)
      background-image url(../assets/imgs/workshop/1.jpg)
    &:nth-child(2)
      background-image url(../assets/imgs/workshop/2.jpg)
    &:nth-child(3)
      background-image url(../assets/imgs/workshop/3.jpg)
    &:nth-child(4)
      background-image url(../assets/imgs/workshop/4.jpg)
    &:nth-child(5)
      background-image url(../assets/imgs/workshop/5.jpg)
.intro
  .cover
    background #161616
    color #fff
    padding 90px 0 120px
    h1
      font-size 45px
      margin-bottom 50px
      font-family 'Noto Sans SC', sans-serif
      font-weight 300
    .guide
      display flex
      flex-flow row nowrap
      justify-content space-between
      font-family 'Noto Sans SC', sans-serif
      font-weight 300
      .guide-item
        width 240px
        border 1px solid #fff
        border-radius 5px
        padding 10px
        font-size 20px
        line-height 1.4em
        text-align center
  .workshop
    margin-top -30px
    padding-bottom 70px
    .intro-step
      position relative
      display flex
      flex-flow row nowrap
      justify-content space-between
      &:before
        content ''
        position absolute
        top 50%
        left 0
        right 0
        height 3px
        background #000
        overflow hidden
      .intro-step-item
        position relative
        display inline-block
        background #fff
        border 2px solid #000
        width 250px
        box-sizing border-box
        padding 20px
        vertical-align middle
        .title
          display flex
          padding-bottom 10px
          align-items center
          h1
            font-size 72px
            color #999999
            font-family 'Noto Sans SC', sans-serif
            font-weight 300
            width 60%
          p
            width 40%
            font-weight bold
        p
          font-size 14px
          line-height 1.5em
    .expert-wapper
      padding-bottom 10px
      ul
        display flex
        flex-flow row wrap
        justify-content space-between
      .expert-item
        display inline-block
        width 30%
        margin-top 15px
        border-bottom 2px solid #000
        line-height 1.5em
        img
          float left
          border-radius 50%
          width 90px
          height 90px
          margin-right 10px
        .info
          display inline-block
        p.title
          font-size 16px
          height 40px
        p.from
          font-size 13px
        p.position
          color #999
        p.brief
          clear both
          padding-top 10px
          text-indent 12px
          line-height 2em


  .overclocking-camp
    background #000
    color #fff
    padding-bottom 60px
    padding-top 1px
    .bg-map
      margin-top -30px
      background url('../assets/imgs/camp_map.png') center 150px no-repeat
      background-size 90% auto
    .intro-step
      display flex
      flex-flow row wrap
      justify-content center
      margin-bottom 50px
      .intro-step-item
        border 1px solid currentColor
        padding 15px 20px
        text-align center
        margin-top -1px
        width 28%
        h3
          font-size 28px
        p
          padding-top 15px
          font-size 16px
          color #999
    .world-innovator
      ul
        display flex
      li
        width 14.25%
        text-align center
        img
          width 100%
        .name
          padding-top 5px
          font-size 20px
          font-weight bold
          height 2em
        .company
          font-size 12px
          line-height 2em
        .position
          color #979797
    .world-innovator-more
      margin 40px 0
      dl
        width 50%
        display inline-block
        line-height 1.8em
        font-size 14px
        vertical-align top
        padding-right 9%
        box-sizing border-box
        dt
          width 10em
          text-align right
          font-weight bold
          float left
        dd
          margin-left 11em
    .member
      li
        display inline-block
        width 14%
        box-sizing border-box
        border-left 2px solid currentColor
        vertical-align top
        padding-left 10px
        margin 10px 0
        .name
          font-size 16px
          font-weight bold
        .company
          font-size 14px
          line-height 2em
        .position
          color #979797

  .field-study
    .container
      margin -30px auto
      background #b2916d
      padding-top 1px
      padding-bottom 80px
      position relative
    .tutor
      ul
        li
          position relative
          display inline-block
          vertical-align middle
          width 16.666%
          margin-bottom 30px
          img
            width 100%
            vertical-align middle
          .tutor-info
            position absolute
            bottom -7px
            left 8%
            right 8%
            z-index 2
            padding 10px
            background #fff
            border-bottom 4px solid currentColor
            h3
              font-size 20px
              font-family 'Noto Sans SC', sans-serif
              font-weight 900
              line-height 20px
            h4
              font-size 12px
              font-family 'Noto Sans SC', sans-serif
              font-weight 400
              line-height 24px
            p
              font-family 'Noto Sans SC', sans-serif
              font-weight 300
              font-size 12px

  .tips
    padding-top 20px
    font-size 12px
    text-align right
    color #999999
    line-height 1.5em

  .intro-img
    img
      width 100%

  .intro-title
    margin 40px 0
    .title
      display inline-block
      padding-right 15px
      border-right 3px solid currentColor
      vertical-align middle
      width 25%
      margin-right 5%
      h1
        font-family 'BebasNeue'
        font-size 40px
        line-height 1em
        text-transform uppercase
        &.cn
          font-family 'FZLTTHCJW--GB1-0'
          line-height 1.2em
          letter-spacing 4px
    p
      display inline-block
      font-size 16px
      line-height 1.5em
      width 60%
      vertical-align middle

  .subhead
    text-align center
    margin 20px 0
    h2
      font-size 24px
      line-height 2em
      font-weight bold
    p
      font-size 18px
@media $media
  .intro
    .tips
      text-align center
    .intro-img
      height 40px
      img
        display none
    .cover
      padding 40px 0 60px
      h1
        font-size 30px
        margin-bottom 20px
        text-align center
      .guide
        flex-flow row wrap
        .guide-item
          width 100%
          font-size 16px
          margin 10px 0
          color #fff
    .workshop
      margin-top -30px
      padding-bottom 40px
      .intro-step
        position relative
        display flex
        flex-flow row wrap
        justify-content space-between
        &:before
          content ''
          position absolute
          top 0
          left 50%
          bottom 0
          width 3px
          height 100%
          background #000
          overflow hidden
        .intro-step-item
          position relative
          display inline-block
          background #fff
          border 2px solid #000
          width 100%
          box-sizing border-box
          height 200px
          padding 20px
          vertical-align middle
          margin-bottom 30px
          &:last-child
            margin-bottom 0px
          .title
            display flex
            padding-bottom 10px
            h1
              font-size 64px
              color #999999
              font-family 'Noto Sans SC', sans-serif
              font-weight 300
              width 50%
            p
              width 50%
              font-weight bold
          p
            font-size 14px
            line-height 1.5em
      .expert-wapper
        ul
          display flex
          flex-flow row wrap
          justify-content space-between
        .expert-item
          position relative
          display inline-block
          width 49%
          margin-top 15px
          border-bottom 2px solid #000
          line-height 1.5em
          text-align center
          .info
            padding-bottom 40px
            width 100%
          p
            text-align left
          img
            float none
            border-radius 50%
            width 80%
            height auto
            margin auto
            margin-bottom 10px
          p.title
            height auto
            font-size 12px
          p.from
            font-size 12px
          p.position
            color #999
          p.brief
            position absolute
            bottom 7px
            clear both
            padding-top 0px
            padding-bottom 0px
            text-indent 0px
            line-height 1.2em

    .overclocking-camp
      background #000
      color #fff
      padding-bottom 60px
      padding-top 1px
      .bg-map
        margin-top -30px
        background url('../assets/imgs/camp_map.png') center 150px no-repeat
        background-size 90% auto
      .intro-step
        display flex
        flex-flow row wrap
        justify-content space-between
        margin-bottom 50px
        .intro-step-item
          border 1px solid currentColor
          padding 15px 20px
          text-align center
          width 100%
          margin-bottom -1px

          h3
            font-size 20px
          p
            padding-top 10px
            font-size 14px
            color #999999
      .world-innovator
        ul
          display block
          overflow auto
          white-space nowrap
        li
          width 38%
          display inline-block
          text-align center
          img
            width 100%
          .name
            padding-top 5px
            font-size 16px
            font-weight bold
            height 2em
          .company
            font-size 12px
            line-height 2em
          .position
            color #979797
      .world-innovator-more
        margin 40px 0
        dl
          width 100%
          display inline-block
          line-height 1.8em
          font-size 12px
          vertical-align top
          padding-right 0%
          box-sizing border-box
          dt
            width 9em
            text-align right
            font-weight bold
            float left
          dd
            margin-left 10em
      .member
        li
          display inline-block
          width 33.333%
          box-sizing border-box
          border-left 2px solid currentColor
          vertical-align top
          padding-left 10px
          margin 10px 0
          .name
            font-size 14px
            font-weight bold
          .company
            font-size 12px
            line-height 2em
          .position
            color #979797

    .field-study
      .container
        margin -30px auto
        background #b2916d
        position relative
        padding-bottom 30px
      .tips
        color #fff
      .tutor
        ul
          white-space nowrap
          overflow auto
          li
            position relative
            display inline-block
            vertical-align middle
            width 120px
            margin-bottom 20px
            img
              width 100%
              vertical-align middle
            .tutor-info
              position absolute
              bottom -7px
              left 8%
              right 8%
              z-index 2
              padding 6px
              background #fff
              border-bottom 2px solid currentColor
              h3
                font-size 16px
                font-family 'Noto Sans SC', sans-serif
                font-weight 900
                line-height 1em
              h4
                font-size 12px
                font-family 'Noto Sans SC', sans-serif
                font-weight 400
                line-height 18px
              p
                font-family 'Noto Sans SC', sans-serif
                font-weight 300
                font-size 12px

    .intro-title
      margin 30px 0
      .title
        padding-right 15px
        border-right 2px solid currentColor
        vertical-align middle
        width 40%
        margin-right 5%
        text-align right
        h1
          font-size 26px
          line-height 1em
          &.cn
            line-height 1.2em
            letter-spacing 0px
      p
        display inline-block
        font-size 12px
        line-height 1.5em
        width 45%

    .subhead
      text-align center
      margin 20px 0
      h2
        font-size 20px
        line-height 2em
        font-weight bold
      p
        font-size 18px
.fieldstudy-list
  position relative
  margin-left -20px
  margin-right -20px
  // width 72vw
  // height 100vh
  // display flex
  // flex-direction column
  // justify-content center
  .tag
    font-size 20px
    color #000
    padding 0 20px
    line-height 3
    margin-top -20px
  .out
    width 100%
  .item
    position relative
    text-align left
    img
      width 100%
    .title
      margin-top -30px
      background #000
      font-size 20px
      color #fff
      padding 0.5em 1em 0.5em 2em
      text-align left
      line-height 1.2
      width 60%
      position relative
    .description
      font-size 13px
      padding 20px
      padding-left 3em
      color #fff
      line-height 1.4
      vertical-align top
      text-align justify

  .next
    position absolute
    left 65vw
    top 21vh
    height 60vh
    width 7vw
    background rgba(0,0,0,0.8)
    z-index 1

  .kz
    position absolute
    left 65vw
    bottom 21vh
    text-align left
    z-index 1
    margin-left -48px
    .arrow-left
    .arrow-right
      width 48px
      display inline-block
      padding 5px 0
      background $yellow
      cursor pointer
      outline none
      img
        width 100%
        vertical-align bottom
    .arrow-left
      padding-left 8px
      margin-right 1px
    .arrow-right
      padding-right 8px
</style>



// WEBPACK FOOTER //
// Intro.vue?53ae7574